<template>
  <div class="w-100 p-2 mt-2">
    <page-header>
      <b-icon-diagram2 class="mr-1"></b-icon-diagram2>
      {{ $t('page.title.dictionary') }}: {{$route.params.entry}}
      <template slot="right">
        <b-button v-required-role="'ROLE_BACKOFFICE_GROUP_POST'" class="mr-1" @click="exportCsvFile()" size="sm"
                  variant="primary">
          {{ $t('dictionary.button.export_dictionary') }}
        </b-button>
        <b-button v-required-role="'ROLE_BACKOFFICE_GROUP_POST'" class="mr-1" @click="openModal('create-import')" size="sm"
                  variant="primary">
          {{ $t('dictionary.button.import_dictionary') }}
        </b-button>
        <b-button @click="createNewDictModal()" size="sm" variant="success">
          {{$t('btn.add_new')}}
        </b-button>
      </template>
    </page-header>

    <div class="card questions sygni-grid">
      <div class="card-header">
        <h3 class="card-title">
          {{$t('title.list')}}: {{$route.params.entry}}
        </h3>
      </div>
      <div class="card-body">
        <div class="row mt-2">
          <div class="col-12">

            <div class="pagination-wrapper justify-content-end">
              <grid-pagination :total-count="totalCount"
                               :per-page="perPage"
                               :current-page="currentPage"
                               @load-items="paginationReload"></grid-pagination>
            </div> <!-- #pagination-wrapper-->

            <div class="table-responsive">
              <b-table striped show-empty
                       :empty-text="$t('table.no_results')"
                       :busy="isBusy"
                       hover
                       head-variant="dark"
                       outlined
                       :sort-by.sync="orderColumn"
                       :sort-desc.sync="orderDirection"
                       :no-local-sorting="true"
                       :items="items"
                       :fields="fields">

                <template #cell(keyCol)="data">
                  <div>{{data.item.key}}</div>
                </template>

                <template #cell(actions)="data">
                  <div class="table-action--cell">
                    <b-button variant="success" size="sm"
                              @click="editEntry(data.item)">
                      {{ $t('table.btn.edit') }}
                    </b-button>
                    <b-button variant="danger" size="sm"
                              @click="deleteItem(data.item)">
                      {{ $t('table.btn.delete') }}
                    </b-button>
                  </div>
                </template>

                <template #table-busy>
                  <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                  </div>
                </template>

              </b-table>
            </div> <!-- #table-responsive-->

            <grid-pagination :total-count="totalCount"
                             :per-page="perPage"
                             :current-page="currentPage"
                             @load-items="paginationReload"></grid-pagination>
          </div>
        </div>
      </div> <!-- #card-body-->
    </div> <!-- #card questions sygni-grid-->
  </div>
</template>

<script>

import axios from "axios";
import GridMixin from "../../../components/grid/GridMixin";
import Vue from "vue";
import EntryModal from "../components/EntryAddModal";
import EntryEditModal from "../components/EntryEditModal";
import GridPagination from "../../../components/grid/grid-pagination/GridPagination";
import PageHeader from "../../../components/page/PageHeader";
import alertify from "alertifyjs";
import CreateImportModal from "../components/CreateImportModal";

export default {
  mixins: [GridMixin],
  components: {
    PageHeader,
    GridPagination
  },
  data() {
    return {
      gridGetUrl: null,
      showDeleted: false,
      orderColumn: 'label',
      orderDirection: true,
      fields: [
        {key: 'key'},
        {key: 'dictionaryAlias', label: this.$t('table.header.dictionary')},
        {key: 'keyCol', label: this.$t('table.header.key'), sortable: true},
        {key: 'label', label: this.$t('table.header.label'), sortable: true},
        {key: 'actions', label: this.$t('table.header.actions'), class: 'text-right'}
      ],
      items: []
    };
  },
  mounted() {
    this.gridGetUrl = `/api/dictionary/${this.$route.params.entry}/entry`;
    this.deleteActionUrl = `/api/dictionary/${this.$route.params.entry}/entry/`;
    this.loadItems();
    this.$on('refresh-dict', () => {
      this.loadItems();
    })
  },
  methods: {
    toggleAllCheckboxes: function (checked) {
      this.selectedRows = [];
      if (checked) {
        let _that = this;
        this.items.forEach((value) => {
          _that.selectedRows.push(value.id);
        })
      }
    },
    createNewDictModal() {
      const
          ModalConstructor = Vue.extend(EntryModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'create-entry';
      modal.title = 'Create entry';

      modal.$mount();
    },
    editEntry(entry) {
      const
          ModalConstructor = Vue.extend(EntryEditModal),
          modal = new ModalConstructor({parent: this});

      modal.name = 'edit-entry';
      modal.title = 'Edit entry';
      modal.form = {
        label: entry.label,
        entryOrder: entry.order,
        entryKey: entry.key,
        isActive: entry.active
      }

      modal.$mount();
    },
    deleteItem: function (item) {
      let _that = this;
      this.$bvModal.msgBoxConfirm(this.$t('modal.title.delete_dictionary_entry_msg')+' '+ item.label + ' Key: ' +item.key, {
        title: this.$t('modal.title.delete_dictionary_entry'),
        okTitle: this.$t('btn.delete'),
        cancelTitle: this.$t('btn.cancel'),
        okVariant: 'danger',
      })
      .then(value => {
        if (value) {
          axios.delete(`/api/dictionary/${this.$route.params.entry}/entry/${item.key}`)
            .then(function () {
              _that.loadItems();
            })
            .catch(error => {
              console.log(error);
            });
        }
      });
    },
    openModal(type) {
      switch (type) {
        case('create-import'): {
          this.$store.commit('modal/openModal', {
            parent: this,
            modal: CreateImportModal,
            modalName: 'createImportModal',
            props: {apiKey: this.apiKey, selectOptions: this.selectOptions}
          });
          break;
        }
      }
    },
    exportCsvFile() {
      const dictionaryName = this.$route.params.entry;

      axios.get(`/api/dictionary/${dictionaryName}/export`)
        .then((response) => {
          const hiddenElement = document.createElement('a');
          hiddenElement.href = 'data:text/csv;charset=utf-8,' + encodeURI(response.data);
          hiddenElement.target = '_blank';
          hiddenElement.download = `Dictionary-${dictionaryName}.csv`;
          hiddenElement.click();
        })
        .catch((error) => {
          alertify.error('Something went wrong');
          console.log(error);
        });
    }
  }
}
</script>
